// import React, { useState } from "react";

function Hero() {
  // const [isOpen, setIsOpen] = useState(false);

  return (
      <section class="hero" id="home">
        <h1>Dive Into Luxury</h1>
        {/* <p>Expert pool design, construction, and maintenance serviceaaas.</p> */}
        <a href="#Pricing" class="btn">View Our Services</a>
    </section>
  );
}


export default Hero;